<template>
  <div v-if="state.transaction?.transaction_id" class="wrapper">
    <transition name="fade" mode="out-in">
      <div v-if="transactionStatus === 'paid'" class="paid-block">
        <img
          src="@/assets/images/illustration/transaction/transaction-paid.svg"
        />
        <h2>Merci pour votre commande !</h2>
        <p>
          Vos crédits ont bien été ajoutés à votre solde total. Vous pouvez dès
          maintenant les utiliser et activer de nouveaux talents.
        </p>
        <p>
          Votre <b>facture</b> a été envoyée à l’adresse e-mail suivante :
          <b>{{ user.email }}</b
          >. Vous pouvez également la retrouver dans
          <b>votre espace organisation</b> sur la plateforme.
        </p>
        <div class="btn-inline">
          <Button
            label="Retour sur la plateforme"
            class="secondary"
            @click="router.push({ name: 'home' })"
          />
          <Button
            v-if="state.pending_activations"
            label="Continuer vers ma campagne de recrutement"
            style="margin-left: 16px"
            class="primary"
            @click="
              router.push({
                name: 'campaign',
                params: {
                  spaceId: state.pending_activations.space_id,
                  campaignId: state.pending_activations.campaign_id,
                },
              })
            "
          />
        </div>
      </div>
      <div
        v-else-if="transactionStatus === 'canceled' || state.isCanceled"
        class="canceled-block"
      >
        <img
          src="@/assets/images/illustration/transaction/transaction-canceled.svg"
        />
        <h2>
          Le paiement de {{ state.transaction.amount_total }}€ à Yuzu a échoué
        </h2>
        <p>
          Votre paiement n’a pas pu être effectué. Cliquez sur « Retour au
          paiement » et optez pour un autre mode de paiement. Si le problème
          persiste, contactez notre
          <span class="virtual-link" @click="crisp.chat.open()">
            Service Client </span
          >.
        </p>
        <Button
          label="Retour sur la plateforme"
          class="primary"
          @click="router.push({ name: 'home' })"
        />
      </div>
      <div v-else-if="state.triggerSupport" class="support-block">
        <h2>Contacter le support</h2>
      </div>
      <div v-else class="loading-block">
        <Loader />
        <h2>Transaction en cours de chargement !</h2>
        <p>
          S’il vous plait, ne fermez pas la fenêtre. L’opération est en cours de
          chargement et ne devrait pendre que quelques secondes.
        </p>
      </div>
    </transition>
  </div>
</template>

<script setup>
import { reactive, onBeforeMount, computed, onMounted, inject } from "vue";
import { useCompanyStore } from "@/stores/company.js";
import { useUserStore } from "@/stores/user.js";
import { useRoute, useRouter } from "vue-router";
import { event } from "vue-gtag";

const crisp = inject("crisp");

const companyStore = useCompanyStore();

const { user } = useUserStore();

const route = useRoute();

const router = useRouter();

const state = reactive({
  pending_activations: false,
  transaction: null,
  fetchTry: 0,
  triggerSupport: false,
  isCanceled: false,
});

function CheckTransaction() {
  const urlSearchParams = new URLSearchParams(window.location.search);
  const params = Object.fromEntries(urlSearchParams.entries());

  if (params.status === "cancel") {
    state.isCanceled = true;
    return;
  }

  const loop = setInterval(async () => {
    state.fetchTry++;

    state.transaction = await companyStore.getCompanyTransaction(
      route.params.companyId,
      route.params.transactionId
    );

    if (transactionStatus.value === "paid") {
      event("purchase", { value: state.transaction.amount_total });
    }

    if (transactionStatus.value !== "waiting") {
      clearInterval(loop);
    }

    if (state.fetchTry > 5) {
      state.triggerSupport = true;
      clearInterval(loop);
    }
  }, 1000);
}

onBeforeMount(async () => {
  state.transaction = await companyStore.getCompanyTransaction(
    route.params.companyId,
    route.params.transactionId
  );

  if (!state.transaction.transaction_id) {
    router.push({ name: "home" });
  }
});

onMounted(() => {
  state.pending_activations = JSON.parse(
    localStorage.getItem("pending_activations")
  );

  setTimeout(() => {
    CheckTransaction();
  }, 2000);
});

const transactionStatus = computed(() => {
  if (state.fetchTry === 0) return "waiting";

  if (state.transaction.paid_time !== null) return "paid";
  if (state.transaction.canceled_time !== null) return "canceled";

  return "waiting";
});
</script>
